import { QueryClient } from '@tanstack/vue-query';

// Crear y exportar una instancia de QueryClient
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Configuración por defecto para todas las consultas
      staleTime: 0, // Por defecto, las consultas se consideran obsoletas inmediatamente
      cacheTime: 5 * 60 * 1000, // 5 minutos de tiempo de caché por defecto
      retry: 1, // Reintentar una vez por defecto
      refetchOnWindowFocus: false, // No recargar al enfocar la ventana
    },
  },
});
